export default __webpack_public_path__ + "static/media/user-13.a5c1b5aa.jpg";